module.exports = __webpack_public_path__ + "img/spellcheck.bcad8398.svg";